import $ from 'jquery';
import Swal from 'sweetalert2';

export function initMapTiang() {
  const pageId = $('#page-id').data('page');
  if (pageId !== 'map-tiang') return;

  const $page = $('#page-id');
  const endpoint = $page.data('endpoint');
  const baseUrl = endpoint ? endpoint.replace(/\/tiang\/map-data.*/, '') : '';

  // Default center point (Middle of Indonesia: Palu approx)
  let centerLat = -0.7893;
  let centerLng = 113.9213;
  let zoomLevel = 5;

  // Use preferCanvas: true for high-performance rendering
  const map = L.map('map-tiang', {
    preferCanvas: true,
    zoomSnap: 0.1, // Allows for smooth, fractional zooming
    zoomDelta: 0.5, // Smaller increments for more control
  });

  // Define Base Layers (Google Maps Styles) with high MaxZoom
  const googleRoadmap = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
    maxZoom: 22,
    maxNativeZoom: 21,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution: 'Google Maps',
  });

  const googleSatellite = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
    maxZoom: 22,
    maxNativeZoom: 21,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution: 'Google Maps',
  });

  const googleHybrid = L.tileLayer('https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}', {
    maxZoom: 22,
    maxNativeZoom: 21,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution: 'Google Maps',
  });

  const googleTerrain = L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
    maxZoom: 22,
    maxNativeZoom: 21,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution: 'Google Maps',
  });

  const osm = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
    attribution: '&copy; OpenStreetMap',
  });

  // Add default layer to map
  googleRoadmap.addTo(map);

  // Layer Control to switch styles
  const baseLayers = {
    'Google Roadmap': googleRoadmap,
    'Google Satellite': googleSatellite,
    'Google Hybrid': googleHybrid,
    'Google Terrain': googleTerrain,
    OpenStreetMap: osm,
  };

  L.control.layers(baseLayers, null, { position: 'topright' }).addTo(map);

  // Handle Auto-Centering based on actual data extent
  const minLat = parseFloat($page.data('min-lat'));
  const maxLat = parseFloat($page.data('max-lat'));
  const minLng = parseFloat($page.data('min-lng'));
  const maxLng = parseFloat($page.data('max-lng'));

  if (!isNaN(minLat) && !isNaN(maxLat) && !isNaN(minLng) && !isNaN(maxLng)) {
    // Center the map precisely around the poles data
    map.fitBounds(
      [
        [minLat, minLng],
        [maxLat, maxLng],
      ],
      { padding: [20, 20], maxZoom: 15 }
    );
  } else {
    // Fallback to default ID view
    map.setView([centerLat, centerLng], zoomLevel);
  }

  window.Swal = Swal;
  // Use FeatureGroup instead of MarkerClusterGroup so no clusters ever appear
  let markersLayer = L.featureGroup().addTo(map);
  let isFetching = false;
  let fetchTimeout;
  let allFetchedMarkers = [];
  let currentFilterStatus = 'total';
  let isFirstLoad = true;
  let renderFrameId = null; // To track and cancel pending render chunks

  const $loading = $('#map-loading-indicator');
  const $overlay = $('#map-overlay');
  const $stats = $('#map-stats');
  const $totalTiangBadge = $('#total-tiang-badge');
  const $filterForm = $('#filter-map-form');

  // Create a subtle corner loading indicator inside the map
  const $cornerLoader = $(`
        <div id="map-corner-loader" style="
            position: absolute; top: 15px; right: 15px; z-index: 1000;
            background: rgba(255,255,255,0.92); backdrop-filter: blur(6px);
            border-radius: 10px; padding: 8px 14px;
            box-shadow: 0 2px 12px rgba(0,0,0,0.1); border: 1px solid rgba(0,0,0,0.06);
            display: none; align-items: center; gap: 8px;
            font-size: 0.75rem; font-weight: 500; color: #555;
            transition: opacity 0.3s ease;
        ">
            <span class="spinner-border spinner-border-sm text-primary" style="width: 14px; height: 14px; border-width: 2px;"></span>
            <span>Memuat data...</span>
        </div>
    `);
  $('#map-tiang').parent().append($cornerLoader);

  // Debounce function to wait for user to stop panning before fetching data
  let isFilterSubmit = false;

  function triggerFetch(isSubmit = false) {
    if (fetchTimeout) clearTimeout(fetchTimeout);
    if (isSubmit) isFilterSubmit = true;
    fetchTimeout = setTimeout(fetchPoles, 600); // 600ms debounce
  }

  // Function to fetch data dynamically based on Map Bounding Box and Zoom
  function fetchPoles() {
    if (isFetching) return;

    isFetching = true;
    $loading.removeClass('d-none');

    // Only show full overlay on very first load; use subtle corner loader afterwards
    if (isFirstLoad) {
      $overlay.removeClass('d-none').addClass('d-flex');
    } else {
      $cornerLoader.css('display', 'flex');
    }

    let dataString = $filterForm.serialize();

    if (isFilterSubmit) {
      dataString += (dataString ? '&' : '') + 'get_extent=1';
    } else {
      const bounds = map.getBounds();
      const zoom = map.getZoom();
      dataString +=
        (dataString ? '&' : '') +
        'swLat=' +
        encodeURIComponent(bounds.getSouthWest().lat) +
        '&swLng=' +
        encodeURIComponent(bounds.getSouthWest().lng) +
        '&neLat=' +
        encodeURIComponent(bounds.getNorthEast().lat) +
        '&neLng=' +
        encodeURIComponent(bounds.getNorthEast().lng) +
        '&zoom=' +
        encodeURIComponent(zoom);
    }

    $.ajax({
      url: endpoint,
      type: 'GET',
      data: dataString,
      success: function (result) {
        if (result.status === 'success') {
          if (result.total_tiang_coords !== undefined) {
            $totalTiangBadge.html(
              `<i class="bi bi-geo-alt me-1"></i> <b>${Number(result.total_tiang_coords).toLocaleString('id-ID')}</b> Tiang`
            );
          }
          if (isFilterSubmit && result.extent && result.extent.minLat) {
            isFilterSubmit = false; // Reset flag
            // Auto-center map, which will trigger moveend and fetch actual data inside bbox
            map.fitBounds(
              [
                [result.extent.minLat, result.extent.minLng],
                [result.extent.maxLat, result.extent.maxLng],
              ],
              { padding: [20, 20], maxZoom: 15 }
            );
            updateStatsCards(result.stats);
          } else {
            isFilterSubmit = false;
            if (result.require_zoom) {
              $stats.html(
                '<i class="bi bi-info-circle me-1 text-warning"></i> Silakan Perbesar (Zoom In) untuk melihat koordinat detail aset.'
              );
              markersLayer.clearLayers();
              allFetchedMarkers = [];
            } else {
              allFetchedMarkers = result.data || [];
              filterAndRenderMarkers();
            }
            updateStatsCards(result.stats);
          }
        } else {
          console.error('Map query error:', result.message);
        }
      },
      error: function (xhr, status, error) {
        console.error('AJAX Map Error:', error);
      },
      complete: function () {
        isFetching = false;
        $loading.addClass('d-none');
        $overlay.addClass('d-none').removeClass('d-flex');
        $cornerLoader.css('display', 'none');
        isFirstLoad = false;
      },
    });
  }

  function updateStatsCards(stats) {
    if (!stats) return;
    $('#stat-total').text(Number(stats.total || 0).toLocaleString('id-ID'));
    $('#stat-selesai').text(Number(stats.selesai || 0).toLocaleString('id-ID'));
    $('#stat-proses').text(Number(stats.proses || 0).toLocaleString('id-ID'));
    $('#stat-kendala').text(Number(stats.kendala || 0).toLocaleString('id-ID'));
    $('#stat-belum-eksekusi').text(Number(stats.belum_eksekusi || 0).toLocaleString('id-ID'));
    $('#stat-waiting').text(Number(stats.waiting || 0).toLocaleString('id-ID'));
  }

  function filterAndRenderMarkers() {
    let filtered = allFetchedMarkers;

    // Get layer toggles state
    const showTiang = $('#toggle-tiang').is(':checked');
    const showInspeksi = $('#toggle-inspeksi').is(':checked');
    const showRow = $('#toggle-row').is(':checked');

    filtered = allFetchedMarkers.filter((item) => {
      // Layer filter
      if (!item.marker_type && !showTiang) return false;
      if (item.marker_type === 'INSPEKSI' && !showInspeksi) return false;
      if (item.marker_type === 'ROW' && !showRow) return false;

      // Status filter
      if (currentFilterStatus !== 'total') {
        if (!item.marker_type) return false;

        const status = (item.status_inspeksi || '').toUpperCase();
        if (currentFilterStatus === 'selesai') {
          return status === 'SELESAI';
        } else if (currentFilterStatus === 'proses') {
          return status === 'WORK_ORDER' || status === 'PROSES' || status === 'DITUGASKAN';
        } else if (currentFilterStatus === 'kendala') {
          return status === 'KENDALA';
        } else if (currentFilterStatus === 'belum_eksekusi') {
          return (
            status === 'TEMUAN' ||
            status === 'BELUM_DI_EKSEKUSI' ||
            status === 'BELUM DI EKSEKUSI' ||
            status === 'DRAFT'
          );
        } else if (currentFilterStatus === 'waiting') {
          return status === 'WAITING_APPROVAL' || status === 'WAITING';
        }
        return false;
      }
      return true;
    });
    renderMarkers(filtered);
  }

  // Render Canvas Markers in chunks to prevent freezing the UI (handles 1000+ assets smoothly)
  function renderMarkers(allData) {
    if (renderFrameId) {
      cancelAnimationFrame(renderFrameId);
      renderFrameId = null;
    }

    console.log('Map Data Received:', allData ? allData.length : 0, 'items');
    markersLayer.clearLayers();

    if (!allData || allData.length === 0) {
      $stats.html('<i class="bi bi-info-circle me-1"></i> Tidak ada data di area ini');
      return;
    }

    const tiangCount = allData.filter((i) => !i.marker_type).length;
    const findingCount = allData.filter((i) => i.marker_type).length;

    $stats.html(
      `<i class="bi bi-geo-alt-fill me-1"></i> <b>${tiangCount}</b> Tiang & <b>${findingCount}</b> Temuan`
    );

    const renderedCoords = {};
    const markerArray = [];

    // Loop synchronously since we are just creating objects (fast)
    for (let i = 0; i < allData.length; i++) {
      const item = allData[i];
      if (
        item.latitude === null ||
        item.longitude === null ||
        item.latitude === undefined ||
        item.longitude === undefined
      )
        continue;

      let lat = parseFloat(item.latitude);
      let lng = parseFloat(item.longitude);

      // Offset logic for exact overlapping coordinates
      if (item.marker_type) {
        const coordKey = `${lat.toFixed(6)},${lng.toFixed(6)}`;
        if (renderedCoords[coordKey]) {
          const count = renderedCoords[coordKey];
          const angle = (count * 2 * Math.PI) / 8; // Distribute markers in a circle
          const radius = 0.00008; // Approx 8 meters radius offset
          lat += Math.cos(angle) * radius;
          lng += Math.sin(angle) * radius;
          renderedCoords[coordKey]++;
        } else {
          renderedCoords[coordKey] = 1;
        }
      }

      let marker;
      let popupHtml = '';

      if (item.marker_type === 'INSPEKSI') {
        // Determine color and status labels based on status_inspeksi
        let pinColorClass = 'pin-danger';
        let statusLabel = (item.status_inspeksi || 'TEMUAN').toUpperCase();
        let badgeClass = 'bg-danger';

        if (
          statusLabel === 'WORK_ORDER' ||
          statusLabel === 'PROSES' ||
          statusLabel === 'DITUGASKAN'
        ) {
          pinColorClass = 'pin-warning';
          badgeClass = 'bg-warning text-dark';
        } else if (statusLabel === 'SELESAI') {
          pinColorClass = 'pin-success';
          badgeClass = 'bg-success';
        } else if (
          statusLabel === 'WAITING' ||
          statusLabel === 'WAITING_APPROVAL' ||
          statusLabel === 'MENUNGGU APPROVE'
        ) {
          pinColorClass = 'pin-primary';
          badgeClass = 'bg-primary text-white';
        } else if (statusLabel === 'KENDALA') {
          pinColorClass = 'pin-orange';
          badgeClass = 'bg-danger text-white';
        }

        // Inspection Finding Marker
        marker = L.marker([lat, lng], {
          icon: L.divIcon({
            html: `
                            <div class="marker-pin-wrapper">
                                <div class="marker-pin ${pinColorClass}"></div>
                                <div class="marker-shadow"></div>
                            </div>
                        `,
            className: 'custom-div-marker',
            iconSize: [24, 34],
            iconAnchor: [12, 34],
          }),
        });

        let fotoHtml = '';
        if (item.foto_temuan) {
          const imgUrl = `${baseUrl}/api/v2/media/view/${item.foto_temuan}`;
          fotoHtml = `
                        <div class="mb-3 text-center">
                            <img src="${imgUrl}" alt="Foto Temuan" class="img-fluid rounded shadow-sm border" style="max-height: 150px; object-fit: cover; width: 100%; cursor: pointer;" onclick="window.open('${imgUrl}', '_blank')">
                        </div>
                    `;
        }

        popupHtml = `
                    <div class="custom-map-card p-1" style="min-width: 250px; font-family: inherit;">
                        <div class="text-center pb-2 mb-2 border-bottom">
                            <span class="badge rounded-pill ${badgeClass} px-3 py-1 mb-2">TEMUAN INSPEKSI</span>
                            <h6 class="fw-bold text-dark mb-1 d-flex align-items-center justify-content-center gap-1" style="font-size: 0.95rem;">
                                ${item.kode_inspeksi}
                                <i class="bi bi-copy text-muted" style="cursor: pointer; font-size: 0.8rem;" onclick="navigator.clipboard.writeText('${item.kode_inspeksi}'); window.Swal.fire({toast: true, position: 'top-end', icon: 'success', title: 'Kode Inspeksi disalin!', showConfirmButton: false, timer: 1500});" title="Salin Kode"></i>
                            </h6>
                            <div class="text-muted small" style="font-size: 0.75rem;"><i class="bi bi-calendar-event me-1"></i>${item.tanggal}</div>
                        </div>
                        ${fotoHtml}
                        <div class="d-flex flex-column gap-2 mb-3">
                            <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                <span class="text-muted">Petugas:</span>
                                <span class="fw-bold text-dark text-end">${item.nama_pegawai || '-'}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                <span class="text-muted">ULP:</span>
                                <span class="fw-bold text-dark text-end">${item.nama_ulp || '-'}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                <span class="text-muted">Penyulang:</span>
                                <span class="fw-bold text-dark text-end">${item.nama_penyulang || '-'}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                <span class="text-muted">Anomali:</span>
                                <span class="fw-bold text-dark text-end">${item.nama_komponen || '-'}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                <span class="text-muted">Kondisi:</span>
                                <span class="fw-bold text-danger text-end">${item.nama_kondisi || '-'}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                <span class="text-muted">Status:</span>
                                <span class="badge ${badgeClass} px-2 py-1">${statusLabel}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center pb-1" style="font-size: 0.78rem;">
                                <span class="text-muted">Koordinat:</span>
                                <span class="fw-bold text-primary text-end" style="cursor: pointer;" onclick="navigator.clipboard.writeText('${parseFloat(item.latitude).toFixed(6)}, ${parseFloat(item.longitude).toFixed(6)}'); window.Swal.fire({toast: true, position: 'top-end', icon: 'success', title: 'Koordinat disalin!', showConfirmButton: false, timer: 1500});">
                                    ${parseFloat(item.latitude).toFixed(6)}, ${parseFloat(item.longitude).toFixed(6)} <i class="bi bi-copy ms-1 text-muted" title="Salin Koordinat"></i>
                                </span>
                            </div>
                        </div>
                        <div class="d-flex gap-2">
                            <a href="https://www.google.com/maps/search/?api=1&query=${item.latitude},${item.longitude}" target="_blank" class="btn btn-xs btn-outline-primary w-100 rounded-pill d-flex align-items-center justify-content-center gap-1 py-1" style="font-size: 0.75rem;">
                                <i class="bi bi-map-fill"></i> Rute Google Maps
                            </a>
                        </div>
                    </div>
                `;
        marker.bindPopup(popupHtml, { className: 'custom-leaflet-popup' });
        marker.bindTooltip(`<b>Inspeksi</b><br>${item.kode_inspeksi}`);
      } else if (item.marker_type === 'ROW') {
        // ROW Finding Marker
        marker = L.marker([lat, lng], {
          icon: L.divIcon({
            html: `
                            <div class="marker-pin-wrapper">
                                <div class="marker-pin pin-purple pin-tree">
                                    <i class="bi bi-tree-fill"></i>
                                </div>
                                <div class="marker-shadow"></div>
                            </div>
                        `,
            className: 'custom-div-marker',
            iconSize: [24, 34],
            iconAnchor: [12, 34],
          }),
        });

        let jarakStr =
          item.jarak_bahaya_tegakan !== null && item.jarak_bahaya_tegakan !== undefined
            ? item.jarak_bahaya_tegakan + ' M'
            : '-';

        const isTegakan = item.kode_row && item.kode_row.startsWith('TGK');
        let statusBadge = `<span class="fw-bold text-dark text-end">-</span>`;
        if (item.kategori) {
          let badgeClass = 'bg-secondary';
          const kat = item.kategori.toUpperCase();
          if (kat === 'KRITIS') badgeClass = 'bg-danger';
          else if (kat === 'BAHAYA') badgeClass = 'bg-warning text-dark';
          else if (kat === 'AMAN') badgeClass = 'bg-success';

          statusBadge = `<span class="badge ${badgeClass} rounded-pill">${item.kategori}</span>`;
        }

        popupHtml = `
                    <div class="custom-map-card p-1" style="min-width: 250px; font-family: inherit;">
                        <div class="text-center pb-2 mb-2 border-bottom">
                            <span class="badge rounded-pill px-3 py-1 mb-2" style="background-color: #6f42c1; color: white;">TEMUAN ${isTegakan ? 'TEGAKAN' : 'ROW'}</span>
                            <h6 class="fw-bold text-dark mb-1" style="font-size: 0.95rem;">${item.kode_row}</h6>
                            <div class="text-muted small" style="font-size: 0.75rem;"><i class="bi bi-calendar-event me-1"></i>${item.tanggal}</div>
                        </div>
                        <div class="d-flex flex-column gap-2 mb-3">
                            <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                <span class="text-muted">ULP:</span>
                                <span class="fw-bold text-dark text-end">${item.nama_ulp || '-'}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                <span class="text-muted">Status Pohon:</span>
                                ${statusBadge}
                            </div>
                            <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                <span class="text-muted">Pohon:</span>
                                <span class="fw-bold text-dark text-end">${item.nama_pohon || '-'}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                <span class="text-muted">Jarak Bahaya:</span>
                                <span class="fw-bold text-danger text-end">${jarakStr}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center pb-1" style="font-size: 0.78rem;">
                                <span class="text-muted">Koordinat:</span>
                                <span class="fw-bold text-primary text-end" style="cursor: pointer;" onclick="navigator.clipboard.writeText('${parseFloat(item.latitude).toFixed(6)}, ${parseFloat(item.longitude).toFixed(6)}'); window.Swal.fire({toast: true, position: 'top-end', icon: 'success', title: 'Koordinat disalin!', showConfirmButton: false, timer: 1500});">
                                    ${parseFloat(item.latitude).toFixed(6)}, ${parseFloat(item.longitude).toFixed(6)} <i class="bi bi-copy ms-1 text-muted" title="Salin Koordinat"></i>
                                </span>
                            </div>
                        </div>
                        <div class="d-flex gap-2">
                            <a href="https://www.google.com/maps/search/?api=1&query=${item.latitude},${item.longitude}" target="_blank" class="btn btn-xs btn-outline-primary w-100 rounded-pill d-flex align-items-center justify-content-center gap-1 py-1" style="font-size: 0.75rem;">
                                <i class="bi bi-map-fill"></i> Rute Google Maps
                            </a>
                        </div>
                    </div>
                `;
        marker.bindPopup(popupHtml, { className: 'custom-leaflet-popup' });
        marker.bindTooltip(`<b>Pohon/ROW</b><br>${item.kode_row}`);
      } else {
        // TIANG (Default Assets) - Lightweight Mode
        let tRadius = 3.5;
        let tFillColor = '#000000'; // Normal
        let tColor = '#ffffff';
        let tWeight = 1.5;

        if (item.is_tripped && !item.is_visited) {
          tRadius = 5.5;
          tFillColor = '#dc3545'; // Merah (Kritis)
          tColor = '#ffcccc';
          tWeight = 2;
        } else if (item.is_tripped && item.is_visited) {
          tRadius = 4.5;
          tFillColor = '#fd7e14'; // Orange (Trip tp sdh dikunjungi)
          tColor = '#ffe8cc';
          tWeight = 2;
        } else if (!item.is_tripped && !item.is_visited) {
          tRadius = 4.5;
          tFillColor = '#0dcaf0'; // Cyan (Belum dikunjungi sama sekali)
          tColor = '#cff4fc';
          tWeight = 2;
        }

        marker = L.circleMarker([lat, lng], {
          radius: tRadius,
          fillColor: tFillColor,
          color: tColor,
          weight: tWeight,
          opacity: 1,
          fillOpacity: 1,
        });

        // Set skeleton loading popup
        popupHtml = `
                    <div class="custom-map-card p-1 text-center" style="min-width: 200px; font-family: inherit;" id="popup-tiang-${item.id_tiang}">
                        <div class="spinner-border text-primary spinner-border-sm mb-2" role="status"></div>
                        <div class="small text-muted">Memuat detail tiang...</div>
                    </div>
                `;

        marker.bindPopup(popupHtml, { className: 'custom-leaflet-popup' });

        // Fetch data when popup opens (Lazy Loading)
        marker.on('popupopen', function () {
          const popupEl = document.getElementById(`popup-tiang-${item.id_tiang}`);
          if (!popupEl) return;

          $.ajax({
            url: `${window.location.origin}/tiang/popup-detail/${item.id_tiang}`,
            type: 'GET',
            success: function (res) {
              if (res.status === 'success' && res.data) {
                const t = res.data;
                const content = `
                                    <div class="text-center pb-2 mb-2 border-bottom">
                                        <span class="badge rounded-pill ${t.status === 'OPERASI' ? 'bg-success' : 'bg-danger'} px-3 py-1 mb-2">${t.status}</span>
                                        <h6 class="fw-bold text-dark mb-1" style="font-size: 0.95rem;"><i class="bi bi-geo-alt-fill text-primary me-1"></i>${t.kode_tiang}</h6>
                                        <div class="text-muted small" style="font-size: 0.75rem;">No. Tiang: ${t.nomor_tiang || '-'}</div>
                                    </div>
                                    <div class="d-flex flex-column gap-2 mb-3">
                                        <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                            <span class="text-muted">UP3:</span>
                                            <span class="fw-bold text-dark text-end">${t.nama_up3 || '-'}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                            <span class="text-muted">ULP:</span>
                                            <span class="fw-bold text-dark text-end">${t.nama_ulp || '-'}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                            <span class="text-muted">Penyulang:</span>
                                            <span class="fw-bold text-dark text-end">${t.nama_penyulang || '-'}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                            <span class="text-muted">Segment:</span>
                                            <span class="fw-bold text-dark text-end">${t.nama_segment || '-'}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                            <span class="text-muted">Trip Penyulang:</span>
                                            <span class="fw-bold ${t.trip_count > 0 ? 'text-danger' : 'text-success'} text-end">${t.trip_count || 0} Kali (Bulan ini)</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                            <span class="text-muted">Status Kunjungan:</span>
                                            <span class="fw-bold ${t.is_visited ? 'text-success' : 'text-danger'} text-end">${t.is_visited ? '<i class="bi bi-check-circle me-1"></i>Sudah (Bulan ini)' : '<i class="bi bi-x-circle me-1"></i>Belum Pernah'}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                            <span class="text-muted">Kabel:</span>
                                            <span class="fw-bold text-dark text-end">${t.jenis_kabel || '-'}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center pb-1 border-bottom" style="font-size: 0.78rem;">
                                            <span class="text-muted">Panjang:</span>
                                            <span class="fw-bold text-dark text-end">${t.panjang_hantaran || '0'} M</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center pb-1" style="font-size: 0.78rem;">
                                            <span class="text-muted">Koordinat:</span>
                                            <span class="fw-bold text-primary text-end" style="cursor: pointer;" onclick="navigator.clipboard.writeText('${parseFloat(t.latitude).toFixed(6)}, ${parseFloat(t.longitude).toFixed(6)}'); window.Swal.fire({toast: true, position: 'top-end', icon: 'success', title: 'Koordinat disalin!', showConfirmButton: false, timer: 1500});">
                                                ${parseFloat(t.latitude).toFixed(6)}, ${parseFloat(t.longitude).toFixed(6)} <i class="bi bi-copy ms-1 text-muted" title="Salin Koordinat"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex gap-2">
                                        <a href="https://www.google.com/maps/search/?api=1&query=${t.latitude},${t.longitude}" target="_blank" class="btn btn-xs btn-outline-primary w-100 rounded-pill d-flex align-items-center justify-content-center gap-1 py-1" style="font-size: 0.75rem;">
                                            <i class="bi bi-map-fill"></i> Rute Google Maps
                                        </a>
                                    </div>
                                `;
                popupEl.parentElement.innerHTML = content;
              } else {
                popupEl.innerHTML = '<div class="text-danger small">Gagal memuat data</div>';
              }
            },
            error: function () {
              popupEl.innerHTML = '<div class="text-danger small">Terjadi kesalahan koneksi</div>';
            },
          });
        });

        if (allData.length < 500) {
          marker.bindTooltip(`<b>${item.nomor_tiang || item.kode_tiang}</b>`, {
            direction: 'top',
            offset: [0, -5],
          });
        }
      }

      markerArray.push(marker);
    }

    // Chunked rendering to prevent browser freeze with FeatureGroup
    let mIndex = 0;
    function renderChunk() {
      const end = Math.min(mIndex + 200, markerArray.length);
      for (let i = mIndex; i < end; i++) {
        markersLayer.addLayer(markerArray[i]);
      }
      mIndex = end;
      if (mIndex < markerArray.length) {
        renderFrameId = requestAnimationFrame(renderChunk);
      }
    }
    renderChunk();
  }

  // Listen to moveend event to fetch markers dynamically inside the visible BBox
  map.on('moveend', function () {
    triggerFetch(false);
  });

  // Initial load
  triggerFetch(false);

  // Handling Filter Submission
  $filterForm.on('submit', function (e) {
    e.preventDefault();
    triggerFetch(true);
  });

  // Handling Reset
  $('#btn-reset-map').on('click', function (e) {
    e.preventDefault();
    $filterForm[0].reset();
    $filterForm.find('.select2').val(null).trigger('change');

    currentFilterStatus = 'total';
    $('.card-stat').removeClass('active').css('border-color', 'transparent');

    triggerFetch(true);
  });

  // Handling click on status cards to filter markers
  $(document).on('click', '.card-stat', function () {
    const h3Id = $(this).find('h3').attr('id');
    const statusMap = {
      'stat-total': 'total',
      'stat-selesai': 'selesai',
      'stat-proses': 'proses',
      'stat-kendala': 'kendala',
      'stat-belum-eksekusi': 'belum_eksekusi',
      'stat-waiting': 'waiting',
    };

    const status = statusMap[h3Id];
    if (!status) return;

    currentFilterStatus = status;

    // Highlight active card
    $('.card-stat').removeClass('active').css('border-color', 'transparent');
    $(this).addClass('active');

    const colorMap = {
      'stat-total': '#0d6efd',
      'stat-selesai': '#198754',
      'stat-proses': '#ffc107',
      'stat-kendala': '#dc3545',
      'stat-belum-eksekusi': '#6f42c1',
      'stat-waiting': '#0dcaf0',
    };
    const color = colorMap[h3Id] || '#0d6efd';
    $(this).css('border-color', color);

    filterAndRenderMarkers();

    // Populate and show the modal
    const statusNames = {
      total: 'Semua Data Inspeksi',
      selesai: 'Data Inspeksi Selesai',
      proses: 'Data Inspeksi Proses',
      kendala: 'Data Inspeksi Kendala',
      belum_eksekusi: 'Data Belum Dieksekusi / WO',
      waiting: 'Data Inspeksi Waiting',
    };
    $('#modalDataTitle').text(statusNames[status] || 'Data Inspeksi');

    const $tbody = $('#tableDataBody');
    $tbody.empty();

    // Filter the items just for the table
    const showInspeksi = $('#toggle-inspeksi').is(':checked');
    let tableData = allFetchedMarkers.filter((item) => {
      if (item.marker_type !== 'INSPEKSI') return false; // Only show Inspeksi data in this modal for now
      if (!showInspeksi) return false;

      if (status !== 'total') {
        const s = (item.status_inspeksi || '').toUpperCase();
        if (status === 'selesai') return s === 'SELESAI';
        if (status === 'proses') return s === 'WORK_ORDER' || s === 'PROSES' || s === 'DITUGASKAN';
        if (status === 'kendala') return s === 'KENDALA';
        if (status === 'belum_eksekusi')
          return (
            s === 'TEMUAN' ||
            s === 'BELUM_DI_EKSEKUSI' ||
            s === 'BELUM DI EKSEKUSI' ||
            s === 'DRAFT'
          );
        if (status === 'waiting') return s === 'WAITING_APPROVAL' || s === 'WAITING';
        return false;
      }
      return true;
    });

    if (tableData.length === 0) {
      $tbody.append(
        '<tr><td colspan="7" class="text-center text-muted py-4">Tidak ada data untuk status ini</td></tr>'
      );
    } else {
      tableData.forEach((item, index) => {
        let badgeClass = 'bg-secondary';
        const statusLabel = (item.status_inspeksi || 'TEMUAN').toUpperCase();

        if (
          statusLabel === 'WORK_ORDER' ||
          statusLabel === 'PROSES' ||
          statusLabel === 'DITUGASKAN'
        ) {
          badgeClass = 'bg-warning text-dark';
        } else if (statusLabel === 'SELESAI') {
          badgeClass = 'bg-success';
        } else if (
          statusLabel === 'WAITING' ||
          statusLabel === 'WAITING_APPROVAL' ||
          statusLabel === 'MENUNGGU APPROVE'
        ) {
          badgeClass = 'bg-primary text-white';
        } else if (statusLabel === 'KENDALA') {
          badgeClass = 'bg-danger text-white';
        }

        $tbody.append(`
                    <tr>
                        <td class="ps-4">${index + 1}</td>
                        <td class="fw-bold text-primary">${item.kode_inspeksi || '-'}</td>
                        <td>${item.tanggal || '-'}</td>
                        <td>${item.nama_komponen || '-'}</td>
                        <td class="text-danger fw-medium">${item.nama_kondisi || '-'}</td>
                        <td><span class="badge ${badgeClass} rounded-pill">${statusLabel}</span></td>
                        <td class="text-center pe-4">
                            <button type="button" class="btn btn-sm btn-outline-primary rounded-pill btn-center-map" 
                                data-lat="${item.latitude}" data-lng="${item.longitude}" title="Lihat di Peta">
                                <i class="bi bi-geo-alt"></i>
                            </button>
                        </td>
                    </tr>
                `);
      });
    }

    const modalEl = document.getElementById('modalDataMap');
    if (modalEl) {
      const modal =
        window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
      modal.show();
    }
  });

  // Handle centering map from table button
  $(document).on('click', '.btn-center-map', function () {
    const lat = parseFloat($(this).data('lat'));
    const lng = parseFloat($(this).data('lng'));

    const modalEl = document.getElementById('modalDataMap');
    if (modalEl) {
      const modal = window.bootstrap.Modal.getInstance(modalEl);
      if (modal) modal.hide();
    }

    map.setView([lat, lng], 18, { animate: true, duration: 1.5 });
  });

  // Handling Layer Switcher (Checkbox)
  $(document).on('change', '.filter-layer-toggle', function () {
    filterAndRenderMarkers();
  });

  // Map needs to know correct sizing if rendered in a container that animates
  setTimeout(() => {
    map.invalidateSize();
  }, 500);
}
